import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';

import Button from '@material-ui/core/Button';
import Form from 'form/Form';
import { TextField } from 'mui-rff';
import MenuItem from '@material-ui/core/MenuItem';
import AdminFormWrapper from 'admin/presentational/AdminFormWrapper';
import AdminFormButtons from 'admin/presentational/AdminFormButtons';
import AdminFormFields from 'admin/presentational/AdminFormFields';
import { getShortDateFormat } from 'helpers/DateHelper';
import NullableDatePicker from 'form/NullableDatePicker';

const SearchStatisticsForm = ({ searchParameters, onSubmit, isSubmitting = false }) => {
    const { appContext } = useAppContext();

    const storageGroupCategoryItems = [{
        key: 'all',
        title: '[all]'
    }].concat(appContext.storageGroupCategories.map(o => ({ key: o.key, title: o.key })));

    return (
        <AdminFormWrapper isSubmitting={isSubmitting}>
            <Form
                initialValues={searchParameters}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <AdminFormFields>
                            <TextField
                                select
                                name="category"
                                label="Category"
                                variant="outlined"
                            >
                                {
                                    storageGroupCategoryItems.map(item =>
                                        <MenuItem key={item.key} value={item.key}>{item.title}</MenuItem>
                                    )
                                }
                            </TextField>
                            <NullableDatePicker
                                name="from"
                                label="From"
                                formatFunc={getShortDateFormat}
                                inputVariant="outlined"
                                nullString={''}
                                nullButtonLabel="Clear"
                            />
                            <NullableDatePicker
                                name="to"
                                label="To"
                                formatFunc={getShortDateFormat}
                                inputVariant="outlined"
                                nullString={''}
                                nullButtonLabel="Clear"
                            />
                        </AdminFormFields>
                        <AdminFormButtons>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Search
                            </Button>
                        </AdminFormButtons>
                    </form>
                )}
            </Form>
        </AdminFormWrapper>
    );
};

SearchStatisticsForm.propTypes = {
    searchParameters: PropTypes.object,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool
};

export default SearchStatisticsForm;
